/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CoupangUploadFile
 */
export interface CoupangUploadFile {
    /**
     * 文件ID
     * @type {number}
     * @memberof CoupangUploadFile
     */
    id?: number;
    /**
     * 文件名
     * @type {string}
     * @memberof CoupangUploadFile
     */
    fileName?: string;
    /**
     * 文件URL
     * @type {string}
     * @memberof CoupangUploadFile
     */
    fileUrl?: string;
    /**
     * 文件类型 文件类型 1 物流附件 2 物流随函 3 装载列表 4 混合列表 5 移动发票 6 入库照片 7 韩国仓库入库早盘 8 韩国仓库出库照片 9 退货附件
     * @type {number}
     * @memberof CoupangUploadFile
     */
    fileType?: number;
}

/**
 * Check if a given object implements the CoupangUploadFile interface.
 */
export function instanceOfCoupangUploadFile(value: object): value is CoupangUploadFile {
    return true;
}

export function CoupangUploadFileFromJSON(json: any): CoupangUploadFile {
    return CoupangUploadFileFromJSONTyped(json, false);
}

export function CoupangUploadFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoupangUploadFile {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'fileType': json['fileType'] == null ? undefined : json['fileType'],
    };
}

export function CoupangUploadFileToJSON(json: any): CoupangUploadFile {
    return CoupangUploadFileToJSONTyped(json, false);
}

export function CoupangUploadFileToJSONTyped(value?: CoupangUploadFile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fileName': value['fileName'],
        'fileUrl': value['fileUrl'],
        'fileType': value['fileType'],
    };
}

